import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center text-start text-sm w-full pe-5 relative truncate ..." }
const _hoisted_2 = { class: "text-xs text-menuColor" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ms-1 me-1 text-xs text-right w-51" }
const _hoisted_6 = {
  key: 0,
  class: "px-665 pt-5 pb-665 border-line"
}
const _hoisted_7 = { class: "ms-2.5 ps-2.5" }
const _hoisted_8 = {
  class: "flex justify-start border-s-2 border-dashed border-darkText",
  style: {"-moz-margin-start":"1px","-webkit-margin-start":"1px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-lightRed relative -start-665" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-2 h-2 rounded-full bg-white" })
  ])
], -1)
const _hoisted_10 = { class: "w-14 text-sm text-start font-bold text-darkText" }
const _hoisted_11 = { class: "text-start mb-1.5" }
const _hoisted_12 = { class: "text-sm mb-2 text-darkText font-semibold" }
const _hoisted_13 = { class: "flex justify-start border-s-2 border-dashed last:border-transparent" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "pt-0.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-2.5 rounded-full bg-white relative -start-665" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-darkText" })
  ])
], -1)
const _hoisted_15 = { class: "w-14 text-sm text-start font-bold text-darkText" }
const _hoisted_16 = { class: "text-start mb-1.5" }
const _hoisted_17 = { class: "text-sm mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "ms-2.5 ps-2.5 pt-4"
}
const _hoisted_20 = { class: "flex relative justify-start border-s-2 border-dashed border-transparent -ms-2.5" }
const _hoisted_21 = { class: "pe-4" }
const _hoisted_22 = { class: "w-18 text-sm font-bold" }
const _hoisted_23 = { class: "relative -top-0.5" }
const _hoisted_24 = { class: "ms-2.5 font-bold text-darkText" }
const _hoisted_25 = { class: "text-start mb-1.125" }
const _hoisted_26 = { class: "text-sm text-darkText" }
const _hoisted_27 = {
  key: 0,
  class: "text-sm mb-3"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex justify-start gap-4 items-center pt-3 px-3" }
const _hoisted_30 = { class: "font-bold text-darkText" }
const _hoisted_31 = { class: "px-2 py-1 text-xs rounded-md border bg-green-100 border-green-200 text-green-600" }
const _hoisted_32 = { class: "ms-2.5 ps-2.5 pt-4" }
const _hoisted_33 = { class: "w-22 text-sm font-bold text-darkText" }
const _hoisted_34 = { class: "relative -top-0.5" }
const _hoisted_35 = { class: "ms-2.5 font-bold text-darkText" }
const _hoisted_36 = { class: "text-start mb-1.125" }
const _hoisted_37 = { class: "flex justify-between w-48 mt-2 mb-3.5 -ms-1.5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/6 mx-1.5 h-3px bg-orange border-s" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/6 mx-1.5 h-3px bg-orange border-s" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/6 mx-1.5 h-3px border-s bg-backgroundGray" }, null, -1)
const _hoisted_41 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 0,
  class: "flex flex-col justify-start border-s-2 border-dashed border-transparent -ms-2.5 mx-4"
}
const _hoisted_43 = { class: "pe-4 flex" }
const _hoisted_44 = { class: "w-22 text-sm font-bold text-darkText" }
const _hoisted_45 = { class: "relative -top-0.5" }
const _hoisted_46 = { class: "ms-2.5 font-bold text-darkText" }
const _hoisted_47 = { class: "text-start mb-1.125" }
const _hoisted_48 = { class: "text-sm ms-7.5" }
const _hoisted_49 = {
  key: 0,
  class: "flex justify-start border-s-2 border-dashed border-transparent -ms-2.5"
}
const _hoisted_50 = { class: "pe-4 mx-5" }
const _hoisted_51 = { class: "w-22 text-sm font-bold text-darkText" }
const _hoisted_52 = { class: "ms-2.5 font-bold text-darkText" }
const _hoisted_53 = { class: "text-start mb-1.125" }
const _hoisted_54 = { class: "text-sm mb-3" }
const _hoisted_55 = { class: "flex justify-between mt-3" }
const _hoisted_56 = { class: "flex" }
const _hoisted_57 = { class: "px-2 py-2 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white rounded-md shadow mb-2 mx-2", _ctx.order.delayTime ? 'shadow-redShadow' : 'shadow-ordersShadow'])
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCollapse())),
      class: _normalizeClass([{ 'border-sidebarBg': _ctx.show, 'shadow-ordersShadow': _ctx.show }, "ps-3 pe-5 py-3 cursor-pointer transition duration-300 flex items-center justify-start order-details-top rounded-md border hover:shadow-ordersShadow border-transparent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.show ? 'text-lightRed' : 'text-darkText', "font-bold pb-1.5"])
          }, _toDisplayString(_ctx.order.orderId), 3),
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.order.orderStatus.value) + " ", 1),
            _createElementVNode("span", {
              class: "px-3",
              innerHTML: _ctx.timeLabel
            }, null, 8, _hoisted_3)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isPrimeOrder)
            ? (_openBlock(), _createBlock(_component_BaseIcon, {
                key: 0,
                name: "prime-order",
                style: {"stroke":"none"},
                class: "mr-2"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.moment(_ctx.order.createdAt).format('hh:mm A')), 1),
          (_ctx.show)
            ? (_openBlock(), _createBlock(_component_BaseIcon, {
                key: 1,
                class: "absolute end-0",
                style: {"width":"14px"},
                name: "arrowup"
              }))
            : _createCommentVNode("", true),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_BaseIcon, {
                key: 2,
                class: "absolute end-0",
                style: {"width":"14px"},
                name: "arrowdown"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('orders.from')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.order.darkStore.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('orders.to')), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.order.userAddress), 1)
              ])
            ])
          ]),
          _hoisted_18,
          (_ctx.order.driver)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_BaseIcon, { name: "truck" })
                      ]),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('orders.driver')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.createDriverFullName(_ctx.order.driver.driverInfo)), 1),
                    (_ctx.order.driver.vehicleInfo)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, "By " + _toDisplayString(_ctx.order.driver.vehicleInfo.vehicleType.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.order.driver)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_28))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('orderCreateModal.erpnextMerchant')), 1),
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.order.erpnextMerchant), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass({'flex justify-between' : _ctx.order.orderStatus.name === 'delivered'})
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-start border-s-2 border-dashed border-transparent -ms-2.5", {'flex-col': _ctx.order.orderStatus.name === 'delivered'}])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["pe-4", {'flex': _ctx.order.orderStatus.name === 'delivered'}])
                }, [
                  _createElementVNode("p", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, [
                      _createVNode(_component_BaseIcon, { name: "clock" })
                    ]),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('orders.duration')), 1)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("div", _hoisted_37, _hoisted_41, 512), [
                    [_vShow, false]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-sm", {'ms-7.5': _ctx.order.orderStatus.name === 'delivered'}])
                  }, _toDisplayString(_ctx.order.estimateTime === 1 ? `${_ctx.order.estimateTime} ${_ctx.$t('orders.minuteRide')}` : `${_ctx.order.estimateTime} ${_ctx.$t('orders.minutesRide')}`), 3)
                ])
              ], 2),
              (_ctx.order.orderStatus.name === 'delivered')
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("p", _hoisted_44, [
                        _createElementVNode("span", _hoisted_45, [
                          _createVNode(_component_BaseIcon, { name: "mappindark" })
                        ]),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('orders.travelDistance')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.order.traveledDistance >= 1000 ? `${Number(_ctx.order.traveledDistance/1000).toFixed(2)} km` : `${_ctx.order.traveledDistance} m`), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.order.delayTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("p", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('orders.delay')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("p", _hoisted_54, _toDisplayString(`${_ctx.order.delayTime} ${_ctx.$t('orders.minutes')}`), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyTrackingLink())),
                  class: "px-2 py-2 me-2"
                }, _toDisplayString(_ctx.$t('buttons.copyTrackingLink')), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("button", _hoisted_57, _toDisplayString(_ctx.$t('buttons.call')), 1),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editOrder(_ctx.order.id, _ctx.order.orderId, _ctx.order.orderStatus.name))),
                  class: "primary px-2 py-2"
                }, _toDisplayString(_ctx.$t('buttons.modifyOrder')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}